export default "__VITE_ASSET__So38$sQV__"